import { render } from "./Contactanos.vue?vue&type=template&id=c0dc9eac"
import script from "./Contactanos.vue?vue&type=script&lang=js"
export * from "./Contactanos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__